import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {CitiesService} from "../../services/api/cities.service";
import TileInterface from "../../dtos/local/Tile.interface";

@Component({
  selector: 'app-system-cities-page',
  templateUrl: './system-cities-page.component.html',
  styleUrls: ['./system-cities-page.component.scss']
})
export class SystemCitiesPageComponent implements OnInit {

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public svc: CitiesService
  ) {
  }

  ngOnInit() {
  }

  async create() {
    await this.router.navigate(['new'], {relativeTo: this.route});
  }

  async edit(tile: TileInterface) {
    // or show create modal?
    await this.router.navigate([tile.tileId], {relativeTo: this.route});
  }

}
